export type ServicesCountLabel = { text: string; title: string | undefined };

export const formatServicesCount = (
  count: number | undefined,
): ServicesCountLabel =>
  count
    ? { text: String(count), title: undefined }
    : { text: "—", title: "No services linked" };
